import { render, staticRenderFns } from "./ManagerJobItem.vue?vue&type=template&id=10052aed&scoped=true"
import script from "./ManagerJobItem.vue?vue&type=script&lang=js"
export * from "./ManagerJobItem.vue?vue&type=script&lang=js"
import style0 from "./ManagerJobItem.vue?vue&type=style&index=0&id=10052aed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10052aed",
  null
  
)

export default component.exports